const CampaignConstants: any = {
  CAMPAIGN_CONFIG: {
    campaignName: "End Of Oak Street",
    GA_EVENTS: {
      CAMPAIGN_CLICK: "campaign_click",
      WATCH_TRAILER_CLICK: "watch_trailer_click",
    },
    campaignVimeoData :  {
      "url1": "1216318650",
      "url2": "93174e7e66",
      "author": "Brian",
      "cityLocation": "",
      "Latitude": 0,
      "Longitude": 0,
      "Interiors": false,
      "Snow": false,
      "Animals": false,
      "DayVideo": false,
      "City": false,
      "Rain": false,
      "Nature": false,
      "Night": false,
      "areControlsFreezed": true,
      "nextButtonText" : "Open a window in another world",
      "locationImage": "assets/oak-street/oak_street_title_1.svg",
      "isTimerEnabled" : true,
      "showTrailerButton" : false,
      "campignRedirectUrl" : 'https://www.endofoakstreet.com/',
      "campaignTrailer" : "https://www.endofoakstreet.com/trailer/"
    },
  },
};
export default CampaignConstants;
